import FingerprintJS from '@fingerprintjs/fingerprintjs'
import PM from './PM'
import BaseProvider from './BaseProvider'

import GameBase from './GameBase'
import Share from './Share'
import UC from './UC'
import Ad from './Ad'

import { LOGGER_PREFIX } from './constants'

export default class TgaPlatform {
  public gameBase: GameBase
  public share: Share
  public uc: UC
  public ad: Ad

  /**
   * 平台SDK初始化
   * @param options 初始化参数
   */
  static async init(options: InitOptions = {}): Promise<TgaPlatform> {
    console.log(`[${LOGGER_PREFIX}] init options`, options)

    const { iframeEle, provider } = options

    const pm = iframeEle
      ? new PM({
          target: iframeEle.contentWindow
        })
      : undefined

    const fp = await FingerprintJS.load()
    const fpId = (await fp.get()).visitorId

    const context = {
      pm,
      fpId,
      provider
    }

    const tgaPlatform = new TgaPlatform()
    tgaPlatform.gameBase = new GameBase(context)
    tgaPlatform.share = new Share(context)
    tgaPlatform.uc = new UC(context)
    tgaPlatform.ad = await Ad.init(context)

    return tgaPlatform
  }
}

type InitOptions = {
  iframeEle?: HTMLIFrameElement
  provider?: BaseProvider
}

export type Context = {
  pm: PM | null
  fpId?: number | string
  provider?: BaseProvider
}

export type CustomError = Error & { code?: number; message?: string }
